module.exports = __webpack_public_path__ + "img/i1.66e5730d.png";